var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6468 27.3882C32.6468 27.3016 32.6468 27.2237 32.6383 27.1457C32.613 26.6954 32.8328 26.2624 33.2133 26.0372L33.2386 26.0199C33.7882 25.6908 33.9827 24.972 33.6614 24.4091L32.7313 22.755C32.41 22.1921 31.7083 21.9929 31.1587 22.322L31.1334 22.3393C30.7698 22.5558 30.3132 22.5558 29.9581 22.322C29.7975 22.2181 29.6284 22.1141 29.4593 22.0275C29.0788 21.8284 28.8505 21.4213 28.8505 20.9883V20.9537C28.8505 20.3042 28.3348 19.7759 27.7007 19.7759H25.8321C25.198 19.7759 24.6823 20.3042 24.6823 20.9537V20.9883C24.6823 21.4213 24.454 21.8284 24.0735 22.0275C23.9044 22.1141 23.7353 22.2181 23.5747 22.322C23.2196 22.5558 22.763 22.5558 22.3994 22.3393L22.3741 22.322C21.8245 21.9929 21.1143 22.1921 20.8015 22.755L19.8714 24.4091C19.5501 24.972 19.7446 25.6995 20.2942 26.0199L20.3195 26.0372C20.7 26.2624 20.9114 26.6954 20.8945 27.1457C20.8945 27.2237 20.886 27.3103 20.886 27.3882C20.886 27.4661 20.886 27.5528 20.8945 27.6307C20.9198 28.081 20.7 28.514 20.3195 28.7392L20.2942 28.7565C19.7446 29.0856 19.5501 29.8044 19.8714 30.3673L20.8015 32.0214C21.1227 32.5843 21.8245 32.7835 22.3741 32.4544L22.3994 32.4371C22.763 32.2206 23.2196 32.2206 23.5747 32.4544C23.7353 32.5584 23.9044 32.6623 24.0735 32.7489C24.454 32.9481 24.6823 33.3551 24.6823 33.7881V33.8227C24.6823 34.4723 25.198 35.0005 25.8321 35.0005H27.7007C28.3348 35.0005 28.8505 34.4723 28.8505 33.8227V33.7881C28.8505 33.3551 29.0788 32.9481 29.4593 32.7489C29.6284 32.6623 29.7975 32.5584 29.9581 32.4544C30.3132 32.2206 30.7698 32.2206 31.1334 32.4371L31.1587 32.4544C31.7083 32.7835 32.4185 32.5843 32.7313 32.0214L33.6614 30.3673C33.9827 29.8044 33.7882 29.0769 33.2386 28.7565L33.2133 28.7392C32.8328 28.514 32.6214 28.081 32.6383 27.6307C32.6468 27.5528 32.6468 27.4748 32.6468 27.3882Z",
    fill: "#106B46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7284 29.7002C27.9752 29.7002 28.9859 28.665 28.9859 27.388C28.9859 26.1109 27.9752 25.0757 26.7284 25.0757C25.4816 25.0757 24.4709 26.1109 24.4709 27.388C24.4709 28.665 25.4816 29.7002 26.7284 29.7002Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1728 17.5583C18.3193 17.5583 21.6807 13.8516 21.6807 9.27917C21.6807 4.70671 18.3193 1 14.1728 1C10.0262 1 6.66479 4.70671 6.66479 9.27917C6.66479 13.8516 10.0262 17.5583 14.1728 17.5583Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6116 33.0686H14.9168H13.3864H5.29509H3.10527C1.94695 33.0686 1 32.1073 1 30.9122V29.5092C1 28.5999 3.13909 21.7064 7.27354 21.4639",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66626 20.3906L13.9867 23.3351C14.2235 23.5949 14.2235 24.0019 13.9783 24.2531L11.222 27.1629C10.926 27.4747 10.4188 27.4227 10.1905 27.059L7.35807 21.8975C7.15516 21.5684 7.27353 21.1267 7.60327 20.9449L8.8715 20.2607C9.14206 20.1135 9.46335 20.1654 9.66626 20.3906Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4486 20.2517C19.1865 20.1132 18.8652 20.1651 18.6622 20.3903L14.3418 23.3348C14.1051 23.5946 14.1051 24.0016 14.3502 24.2527L17.1065 27.1626",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2496 20.7802C10.6808 20.581 10.9852 20.1567 11.0359 19.6631L11.2473 16.9697",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0643 16.9697L17.2757 19.6544C17.3264 20.1653 17.6393 20.5897 18.0789 20.7889",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.e972d405b3d59dee1644a9707b45c406.svg";
export { ForwardRef as ReactComponent };